const {namespaceMapping: nsMapping} = require('@wix/document-services-json-schemas')
const {
    migrateStructuredMegaMenuSubmenuDesign: componentMigrationMigrateStructuredMegaMenuSubmenuDesign,
    SUBMENU_COMPONENT_TYPE
} = require('@wix/component-migration/migrateStylableHorizontalMenuToNewMenu')

const {NAMESPACE_MAPPING} = nsMapping

const COMPONENT_STYLE_TYPE = 'ComponentStyle'
const VARIANT_RELATION_TYPE = 'VariantRelation'

const migrateStructuredMegaMenuSubmenuDesign = (pageManager, component) => {
    const {components: megaMenuContainerItems} = component

    const submenuComponents = megaMenuContainerItems.reduce((acc, megaMenuContainerItem) => {
        const {components: megaMenuContainerItemComponents} = megaMenuContainerItem

        if (megaMenuContainerItemComponents.length === 0) return acc

        const componentsWithSubmenuType = megaMenuContainerItemComponents.filter(
            megaMenuContainerItemComponent => megaMenuContainerItemComponent.componentType === SUBMENU_COMPONENT_TYPE
        )

        return [...acc, ...componentsWithSubmenuType]
    }, [])

    if (submenuComponents.length === 0) return

    const submenuComponentStyleItems = submenuComponents.reduce((acc, submenuComponent) => {
        const styleItem = pageManager.data.getItem(NAMESPACE_MAPPING.style, submenuComponent.styleId)

        if (styleItem.type === COMPONENT_STYLE_TYPE) {
            return [...acc, styleItem]
        }

        const styleItems = styleItem.values.map(styleKey => {
            const cleanedStyleKey = styleKey.replace('#', '')
            const currentBreakpoint = pageManager.data.getItem(NAMESPACE_MAPPING.style, cleanedStyleKey)

            if (currentBreakpoint.type === VARIANT_RELATION_TYPE) {
                const variantKey = currentBreakpoint.to.replace('#', '')
                const variantStyleItem = pageManager.data.getItem(NAMESPACE_MAPPING.style, variantKey)

                return variantStyleItem
            }

            return currentBreakpoint
        })

        return [...acc, ...styleItems]
    }, [])

    componentMigrationMigrateStructuredMegaMenuSubmenuDesign(submenuComponentStyleItems)
}

module.exports = {
    migrateStructuredMegaMenuSubmenuDesign
}
